import styled from 'styled-components';

const TimeBlock = styled.div`
  .time-line {
    width: 8px;
    height: 59px;
    position: absolute;
    top: 0;
    left: 0;
  }

  .time-indicator {
    text-align: center;
    line-height: 110%;
    padding: 0 12px;
    font-size: 18px;
    display: flex;
    align-items: center;
    min-height: 3.3em;
    height: 3.3em;
    position: relative;
    justify-content: center;
    span {
      display: inline-block;
      width: 100%;
      white-space: nowrap;
    }
  }
`;

export default {
  TimeBlock
};